import type { IVirtualTourProvider } from '@bb/domain/dist/types';

interface VirtualTourUrlBuilderProps {
  type: IVirtualTourProvider;
  identifier: string;
  queryString?: boolean;
}

const virtualTourUrlBuilder = ({
  type,
  identifier,
  queryString = false,
}: VirtualTourUrlBuilderProps): string | null => {
  switch (type) {
    case 'matterport':
      return `https://my.matterport.com/show?m=${identifier}${
        queryString ? '&qs=1&log=0&vr=0&mls=2' : ''
      }`;
    case 'iguide':
      return `https://unbranded.youriguide.com/${identifier}${
        queryString
          ? '?noinitanimation&page=tour&noautoplay=1&nomenu=1&minfp=1'
          : ''
      }`;
    case 'realvision':
      return `https://real.vision/${identifier}?o=u`;
    default:
      return null;
  }
};

export default virtualTourUrlBuilder;
